import HttpClient from '../../../gateway/HttpClient';
import { notBlank, notUndefined } from '../../../util/Assert';
import HttpMethod from '../../../constant/HttpMethod';
import { EntityMethods } from '../../../constant/MethodNames';
import { query } from '@trlogic/client-js';
import { CancelToken } from 'axios';
import { EntityData } from '../../../domain/stream/transaction/EntityDomains';
import EntityClient from './EntityClient';

class NestEntityClient implements EntityClient {
  private readonly httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    notUndefined(httpClient, 'Http client cannot be undefined');
    this.httpClient = httpClient;
  }

  public getEntityData(
    channel: string | undefined,
    version: string,
    query: query.SelectQuery,
    token?: CancelToken,
  ): Promise<{
    data: EntityData[];
    count: number;
  }> {
    const dto = {
      channel,
      version,
      query,
    };
    return this.httpClient.execute(HttpMethod.POST, EntityMethods.GET_DATA, dto, undefined, undefined, undefined, token);
  }

  public updateEntityNote(channel: string, version: string, id: string, users: string[]): Promise<void> {
    notUndefined(channel, 'Channel cannot be undefined');
    notBlank(channel, 'Domain cannot be blank');
    notUndefined(version, 'Version cannot be undefined');
    notBlank(version, 'Version cannot be blank');
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');

    const dto = {
      channel,
      version,
      id,
      users,
    };
    return this.httpClient.execute(HttpMethod.POST, EntityMethods.UPDATE_NOTE, dto);
  }

  public commentEntity(domain: string, id: string, comment: string): Promise<void> {
    notUndefined(domain, 'Channel cannot be undefined');
    notBlank(domain, 'Domain cannot be blank');
    notUndefined(id, 'Id cannot be undefined');
    notBlank(id, 'Id cannot be blank');
    notUndefined(comment, 'Comment cannot be undefined');
    notBlank(comment, 'Comment cannot be blank');

    const dto = {
      domain,
      id,
      comment,
    };
    return this.httpClient.execute(HttpMethod.POST, EntityMethods.COMMENT, dto);
  }

  public commentEditEntity(domain: string, comment: string, commentId: string): Promise<void> {
    notUndefined(domain, 'Channel cannot be undefined');
    notBlank(domain, 'Domain cannot be blank');
    notUndefined(comment, 'Comment cannot be undefined');
    notBlank(comment, 'Comment cannot be blank');
    notUndefined(commentId, 'Comment id cannot be undefined');
    notBlank(commentId, 'Comment id cannot be blank');

    const dto = {
      domain,
      comment,
      commentId,
    };
    return this.httpClient.execute(HttpMethod.POST, EntityMethods.COMMENT_EDIT, dto);
  }
}

export default NestEntityClient;
